import { render } from "./InvoiceListHistory.vue?vue&type=template&id=a08f937c"
import script from "./InvoiceListHistory.vue?vue&type=script&lang=js"
export * from "./InvoiceListHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__